import { connect, injectReducer, injectSaga } from '@vfde-sails/core';
import * as mapDispatch from './action';
import leadManagementReducer from './reducer';
import { NameSpace } from '../../enum';
import { mapStateToProps } from './selector';
import { LeadManagementId } from './enum';
import { Title } from './enum';
import { mountButton } from '../../components/button';
import { formValidation } from '@vfde-brix/ws10/validation';
import { mountFormElement } from '../../components/formElement';
import { EMAIL_VALIDATIONS, FIRSTNAME_VALIDATIONS, LASTNAME_VALIDATIONS } from './constants';
import saga from './saga';
import { markAsRequired } from './util/markAsRequired';
import { mountNotification } from '../../components/notification';
import { getUpdateFlags } from './util/update';
import { setElementVisibility } from '../../util/visibility';

export type State = ReturnType<typeof mapStateToProps>;
export type Actions = typeof mapDispatch;

function leadManagement(state: State, actions: Actions) {
    injectSaga(NameSpace.LEAD_MANAGEMENT, saga);
    injectReducer(NameSpace.LEAD_MANAGEMENT, leadManagementReducer);

    const titleOnChange = (value: string) => actions.setForm({ title: value as Title });
    const firstNameOnChange = (value: string) => actions.setForm({ firstName: value });
    const lastNameOnChange = (value: string) => actions.setForm({ lastName: value });
    const emailOnChange = (value: string) => actions.setForm({ email: value });

    const title = mountFormElement(LeadManagementId.TITLE_INPUT, titleOnChange);
    const firstName = mountFormElement(LeadManagementId.FIRSTNAME_INPUT, firstNameOnChange, FIRSTNAME_VALIDATIONS);
    const lastName = mountFormElement(LeadManagementId.LASTNAME_INPUT, lastNameOnChange, LASTNAME_VALIDATIONS);
    const email = mountFormElement(LeadManagementId.EMAIL_INPUT, emailOnChange, EMAIL_VALIDATIONS);
    const submitButton = mountButton(LeadManagementId.SUBMIT, actions.submitLeadManagementForm);

    mountNotification(LeadManagementId.RESULT_NOTIFICATION);
    mountNotification(LeadManagementId.ERROR_NOTIFICATION);

    if (title && firstName && lastName && email && submitButton) {
        formValidation({
            formFields: [title, firstName, lastName, email],
            submitButton,
        }, true, true);

        markAsRequired([firstName, lastName, email]);
    }

    return {
        getDerivedStateFromProps(newState: State, oldState: State) {
            const update = getUpdateFlags(newState, oldState);

            update.result && setElementVisibility(LeadManagementId.FORM, !newState.result.status);
            update.result && setElementVisibility(LeadManagementId.RESULT_NOTIFICATION, newState.result.status);
            update.error && setElementVisibility(LeadManagementId.ERROR_NOTIFICATION, newState.error);
        },
    };
}

const leadManagementContainer = connect(mapStateToProps, mapDispatch)(leadManagement);

export default leadManagementContainer;
